export default {
  transferCheck: '/v3/order/transfer/check',
  transferSubmit: '/courier/api/v2/order/transfer/submit'
}
